import themeGet from '@styled-system/theme-get';
import styled, { css } from 'styled-components';

import Container from '../Container';
import { fixPropWarnings } from '../../utils/fixPropWarnings';

export const CTABannerSection = styled.div.withConfig(fixPropWarnings('variant'))`
  padding: 1.5rem 0;
  color: ${themeGet('colors.white')};
  background: ${themeGet('colors.carbon')};

  ${({ $variant }) => $variant === 'light' && css`
    background: ${themeGet('colors.white')};
    color: ${themeGet('colors.carbon')};
  `}

${({ $variant }) => $variant === 'grey' && css`
    background: ${themeGet('colors.greys.1')};
    color: ${themeGet('colors.carbon')};
    font-size: ${themeGet('typography.desktop.heading4.fontSize')};

    @media (max-width: ${themeGet('breakpoints.md')}) {
      font-size: ${themeGet('typography.mobile.heading5.fontSize')};
    }
  `}

  p {
    margin: 0 1em;
  }
`;

export const Content = styled(Container)`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
`;
